<template>
    <div>
        <b-row class="pb-2">
            <b-col md="12" xl="6">
                <app-detalhe titulo="Ata Direx: " :size="size">
                    <strong>{{ ataDirex.nuAtaDirex }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Tipo Ata Direx: " :size="size">
                    <strong> {{ ataDirex.tipoAta }} </strong>
                </app-detalhe>
                <app-detalhe titulo="Data Reunião: " :size="size">
                    <strong
                        >{{
                            ataDirex.dtReuniao
                                ? $moment(ataDirex.dtReuniao).format(
                                      'DD/MM/YYYY'
                                  )
                                : ''
                        }}
                    </strong>
                </app-detalhe>
                <app-detalhe titulo="Situação: " :size="size">
                    <strong>{{ ataDirex.situacaoAta }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Qtd. Processos: " :size="size">
                    <strong>{{ ataDirex.quantidadeProcessos }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Encaminhados: " :size="size">
                    <strong>{{
                        ataDirex.quantidadeProcessosEncaminhados
                    }}</strong>
                </app-detalhe>
            </b-col>
            <b-col md="12" xl="6">
                <app-detalhe titulo="Processos: " :size="size">
                    <strong>{{ ataDirex.processos }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Processos Encaminhados: " :size="size">
                    <strong>{{ ataDirex.processosEncaminhados }}</strong>
                </app-detalhe>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    props: {
        ataDirex: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            size: '100',
            showModal: false
        }
    }
}
</script>
